// Provide asPath instead of query object as the asPath reflects what's in the url and seen by Google.
// The query object can contain default/unrelevant values which will get filtered out when building the url.
export function getRobotsOverride(asPath: string, resultsCount?: number): string | undefined {
	// don't index pages with less than 5 results
	// only check this if page has results, to avoid not indexing pages that don't fetch this data on the server
	if (resultsCount !== undefined && resultsCount < 5) {
		return 'noindex, follow';
	}

	const [, params] = asPath.split('?');
	const query = new URLSearchParams(params);
	const paramsArray = Array.from(query.keys());

	if (paramsArray.length === 0) {
		return undefined;
	}

	// don't index search pages with query params, except when the page only has 'page' params,
	// as we want Google to see as many accommodations as possible
	if (paramsArray.every((param) => param === 'page')) {
		return undefined;
	}

	return 'noindex, follow';
}
